export default [
  {
    header: 'Dashboards',
    icon: 'HomeIcon',
    children: [
      {
        title: 'ภาพรวมระบบ',
        route: 'dashboard-ecommerce',
        icon: 'ShoppingCartIcon',
      },
      {
        title: 'ภาพรวมระบบภายในหน่วยงาน',
        route: 'dashboard-analytics',
        icon: 'ActivityIcon',
      },
    ],
  },
]
